import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const AdminRoute = ({ children }) => {
  const { isAuthenticated, isAdmin, loading } = useAuth();

  if (loading) {
    return;
  }

  // Verificar se o usuário está autenticado
  if (!isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  // Verificar se o usuário é administrador
  if (!isAdmin()) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default AdminRoute;
